module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1051-ecd941e993eef90439c00604108c0c16.png";